

export function replaceSpacesTo(sentence, symbol = '_') {
  if (sentence) {
    return sentence.replace(/\s/g, symbol);
  } else {
    return '___'
  }
}